import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormTitle = styled.h1`
  color: #1e2a47;
  margin-bottom: 10px;
  font-size: 24px;
`;

export const Subtitle = styled.p`
  color: #666;
  margin-bottom: 30px;
`;

export const InputGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const ResultsContainer = styled.div`
  flex: 1;
  border-radius: 8px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

export const AmountContainer = styled.div`
  background: #ecf6ff;
  padding: 24px;
  border-radius: 12px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FinalAmount = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

export const Amount = styled.div`
  color: #15803d;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
`;

export const AmountText = styled.div`
  color: #666;
  font-size: 12px;
`;

export const AmountInWords = styled.div`
  font-size: 12px;
  margin-top: 4px;
  text-transform: capitalize;
`;

export const StatsGrid = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.columns || 2}, 1fr)`};
  gap: 20px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const StatBox = styled.div`
  padding: 16px;
  border-radius: 8px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const StatLabel = styled.div`
  color: #666;
  margin-bottom: 8px;
  font-size: 12px;
`;

export const StatValue = styled.div<{ isWealth?: boolean }>`
  color: ${(props) => (props.isWealth ? '#15803D' : '#1e2a47')};
  font-size: 16px;
  font-weight: 600;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: auto;
`;

export const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  background: white;
  color: #1e2a47;
  cursor: pointer;
  font-weight: 500;
  border: 1px solid #1e2a47;
  min-width: 120px;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f7fb;
  }
`;

export const ChartContainer = styled.div`
  padding: 20px;
  min-height: 240px;

  @media (max-width: 768px) {
    padding: 10px 0;
  }
`;
